import type { Tool, ApiResponse } from './types';
import { apiGet, apiPost, apiPut } from '../services/api';

export async function getTool(id: string): Promise<Tool> {
  try {
    const res = await apiGet<ApiResponse<Tool>>(`/tools/${id}`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch tool');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function listTools(): Promise<Tool[]> {
  try {
    const res = await apiGet<ApiResponse<Tool[]>>('/tools');
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch tools');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function createTool(data: Partial<Tool>): Promise<Tool> {
  try {
    const res = await apiPost<ApiResponse<Tool>>('/tools', data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to create tool');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function updateTool(id: string, data: Partial<Tool>): Promise<Tool> {
  try {
    const res = await apiPut<ApiResponse<Tool>>(`/tools/${id}`, data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to update tool');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}